module.exports = {
  INVITED: 'invited',
  VALIDATED: 'validated',
  DISABLED: 'disabled',
};
